import { call, put, takeEvery } from "redux-saga/effects";

import {
  LEADS_LIST,
  LEADS_LISTA,
  LEADS_FILTER,
  LEADS_CREATE,
  LEADS_UPDATE,

  LEADS_DELETE,

} from "./actionTypes";

import {
  
  leadsListSuccess,
  leadsCreateSuccess,
  leadsUpdateSuccess,
  leadsRequestFailed,
  leadsDeleteSuccess,

 
} from "./actions";

import {
  getLeadsList,
  getLeadsLista,
  getLeadsFilter,
  postLeadsCreate,
  patchLeadsUpdate,

  deleteLeads
} from "../../helpers/backend";



function*leadsListSaga() {
  console.log("Trayendo lista de leads...");
  try {
    const response = yield call(getLeadsList);
    if (response.status === 200) {
      yield put(leadsListSuccess(response.data));
    } else {
      yield put(leadsRequestFailed(response.data));
    }
  } catch (error) {
    yield put(leadsRequestFailed(error.response.data));
  }
}

function*leadsListaSaga() {
  console.log("Trayendo lista de leads...");
  try {
    const response = yield call(getLeadsLista);
    if (response.status === 200) {
      yield put(leadsListSuccess(response.data));
    } else {
      yield put(leadsRequestFailed(response.data));
    }
  } catch (error) {
    yield put(leadsRequestFailed(error.response.data));
  }
}

function*leadsCreateSaga({ payload:leads }) {
  console.log("Creando nuevo leads...");
  try {
    const response = yield call(postLeadsCreate,leads);
    if (response.status === 201) {
      yield put(leadsCreateSuccess(response.data));
    } else {
      yield put(leadsRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(leadsRequestFailed(error.response.data));
  }
}

function*leadsFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getLeadsFilter, { changeUrl });
    if (response.status === 200) {
      yield put(leadsListSuccess(response.data));
    } else {
      yield put(leadsRequestFailed(response.data));
    }
  } catch (error) {
    yield put(leadsRequestFailed(error.response.data));
  }
}

function*leadsUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos de la herramienta...");
  
  try {
    const response = yield call(patchLeadsUpdate,  id , data);
    if (response.status === 200) {
      yield put(leadsUpdateSuccess(response.data));
      
      
    } else {
      yield put(leadsRequestFailed(response.data));
      
    }
  } catch (error) {
    yield put(leadsRequestFailed(error.response.data));
    
  }
}

function*leadsDeleteSaga({ payload: { id } }) {
  console.log("Borrando datos del Grupo...");
  try {
    const response = yield call(deleteLeads, id );
    if (response.status === 204) {
      yield put(leadsDeleteSuccess(response.data));
    } else {
      yield put(leadsRequestFailed(response.data));
    }
  } catch (error) {
    yield put(leadsRequestFailed(error.response.data));
  }
}


export default function*leadsSaga() {
  yield takeEvery(LEADS_LIST,leadsListSaga);
  yield takeEvery(LEADS_LISTA,leadsListaSaga);
  yield takeEvery(LEADS_FILTER,leadsFilterSaga);
  yield takeEvery(LEADS_CREATE,leadsCreateSaga);
  yield takeEvery(LEADS_UPDATE,leadsUpdateSaga);
 
  yield takeEvery(LEADS_DELETE,leadsDeleteSaga);
}
